import { ProductCodesFilters } from '../models/productCodes';

export const productCodesQueries = {
  all: ['productCodes'] as const,
  list: (filters: ProductCodesFilters) => [...productCodesQueries.all, filters],
  infinityList: (filters: ProductCodesFilters) => [...productCodesQueries.all, filters],
  detail: (id: string) => [...productCodesQueries.all, 'detail', id],
};
